module.exports = __webpack_public_path__ + "static/img/offline-vip-icon.c0e58fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-welfare/offline-vip-icon.png
// module id = gOPA
// module chunks = 216